<template>
  <div class="borrowMoneylist">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="formData"
      @Refresh="onHandleRefresh"
      @search="onSearch"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleExport"
          type="warning"
          icon="el-icon-upload2"
          :disabled="disabledExport"
          >导出</el-button
        >
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->

    <!-- 列表 start -->
    <div class="table-wrap">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column label="品牌名" prop="loanAd.brand" align="center">
        </el-table-column>
        <el-table-column label="客户姓名" prop="userName" align="center">
        </el-table-column>
        <el-table-column label="点击时间" prop="createTime" align="center">
        </el-table-column>
        <el-table-column label="客户电话" prop="userPhone" align="center">
        </el-table-column>
      </el-table>
    </div>
    <!-- 列表 end -->

    <!-- 分页 start -->
    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import cloneDeep from "lodash/cloneDeep";
import { recordlistexport } from "@/api/export/center.js";
export default {
  name: "CityStoreManage",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "select",
          name: "品牌名",
          clearable: true,
          model: "loanAdId",
          placeholder: "请选择品牌名",
          selectoptionname: "lloanAdIdList",
          label: "brand",
          value: "id",
          selectoption: [],
        },
      ],
      loading: false,

      formData: {
        loanAdId: "", //
        page: 1,
        pageSize: 100,
      }, // 表单参数
      formDataClone: {}, // 表单参数拷贝，用于重置
      tableData: [], // 城市仓列表
      total: 0,
      disabledExport: false, // 导出按钮
    };
  },
  mounted() {
    this.formData.loanAdId = Number(this.$route.query.id);
    this.onInitData();
    this.hqlist();
  },
  methods: {
    hqlist() {
      this.$api.borrowMoney
        .categorieslist({
          page: 1,
          pageSize: 99999999,
        })
        .then((res) => {
          this.Filtersearchlist.forEach((el) => {
            if (el.selectoptionname && el.selectoptionname == "lloanAdIdList") {
              el.selectoption = [...res.data.data];
            }
          });
        });
    },
    /**
     * 导出逻辑
     */
    async onHandleExport() {
      this.disabledExport = true;
      try {
        const query = {
          ...this.formData,
          token: sessionStorage.getItem("token"),
        };
        delete query.page;
        delete query.pageSize;
        await recordlistexport(query);
        this.goExportCenter();
      } catch (err) {
        console.log("ajax postPurchaseSettleExport err", err);
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    ajaxGetTableList() {
      this.loading = true;
      this.$api.borrowMoney.getGuideRecord(this.formData).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    /**
     * 初始化
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetTableList();
    },

    /**
     * 重置表单，并刷新
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.ajaxGetTableList();
    },
    /**
     * 搜索表单
     */
    onSearch(e) {
      this.formData = e;
      this.formData.page = 1;
      this.ajaxGetTableList();
    },

    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.pageSize = val;
      this.ajaxGetTableList();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.ajaxGetTableList();
    },
  },
};
</script>
<style lang="scss">
.borrowMoneylist {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .table-wrap {
    flex-grow: 1;
    overflow-y: hidden;
    .text-btn {
      color: $theme-color;
      cursor: pointer;
    }
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
